import * as React from "react";
import * as moment from "moment";
import DateUtils from "../../../../utils/DateUtils";
import "./presenter.scss";
import DropDownWrapper from "../../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import classNames = require("classnames");

interface IProps {
	value: string[];
}

export const AppointmentPresenter: React.SFC<IProps> = (props) => {
	return (
		<AppointmentPresenterComponent values={props.value.map(v => moment(v))} />
	);
};


interface IPresenterProps {
	/**
	 * Values
	 */
	values: moment.Moment[];
}

interface IState {
	/**
	 * Show list
	 */
	showList: boolean
}

export class AppointmentPresenterComponent extends React.Component<IPresenterProps, IState> {
	constructor(props: IPresenterProps) {
		super(props);
		this.state = { showList: false };
		this.onClick = this.onClick.bind(this);
	}

	render() {
		return (
			<div className={"presenter-appointment"}>
				{this.props.values.length > 0 && <span>{this.props.values[0].format(DateUtils.DATE_TIME_FORMAT)}</span>}
				{this.renderMultipleDates()}
			</div>
		);
	}

	renderMultipleDates() {
		if(this.props.values.length > 1) {
			const buttonClass = classNames({
				"button" : true,
				"selected" : this.state.showList
			});
			return (
				<React.Fragment>
					<span className={buttonClass} onClick={this.onClick}>+{this.props.values.length-1} <i className={"fa fa-fw fa-caret-down"}/></span>
					{this.state.showList && <DropDownWrapper width={240} onOutsideClick={() => this.setState({showList: false})}>
						<div className={"other-text"}>OTHER APPOINTMENTS</div>
						{this.renderDates(this.props.values.slice(1))}
					</DropDownWrapper>}
				</React.Fragment>
			)
		}
		return null;
	}

	renderDates(dates: moment.Moment[]) {
		return dates.map(d => <div key={d.toISOString()} className={"other-date"}>{d.format(DateUtils.DATE_TIME_FORMAT)}</div>)
	}

	onClick(evt: React.MouseEvent<HTMLSpanElement>) {
		if(!this.state.showList) {
			this.setState({showList: true})
		}
		evt.stopPropagation();
	}

};
